"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 * @format
 * 
 */
// No-op class implementation for Open Source
var FBLogMessage =
/*#__PURE__*/
function () {
  function FBLogMessage(_) {}

  var _proto = FBLogMessage.prototype;

  _proto.mustfix = function mustfix() {};

  _proto.warn = function warn() {};

  _proto.info = function info() {};

  _proto.debug = function debug() {};

  _proto.catching = function catching() {};

  _proto.blameToPreviousFile = function blameToPreviousFile() {};

  _proto.blameToPreviousFrame = function blameToPreviousFrame() {};

  _proto.blameToPreviousDirectory = function blameToPreviousDirectory() {};

  _proto.addMetadata = function addMetadata() {};

  return FBLogMessage;
}();

module.exports = FBLogMessage;